<template>
  <div id="app">
    <notifications></notifications>
    <router-view/>
  </div>
</template>

<script>
import axios from "axios";
import "../node_modules/nprogress/nprogress.css";
import NProgress from "nprogress";

export default {
  data: function() {
    return {
      IsUnauthorizeError: false,
    };
  },
  created() {
    axios.interceptors.request.use(
      (config) => {
        NProgress.start();
        // trigger 'loading=true' event here
        return config;
      },
      (error) => {
        NProgress.done();
        // trigger 'loading=false' event here
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        NProgress.done();
        // trigger 'loading=false' event here
        this.IsUnauthorizeError = false;
        return response;
      },
      (error) => {
        NProgress.done();
        return Promise.reject(error);
      }
    );
  },
};
</script>
